import React from 'react';
import CustomCheckbox from './CustomCheckbox';
import { CSSTransition } from 'react-transition-group';
import FilterCounter from "./FilterCounter";
import CloseFilterButton from "./CloseFilterButton";
import { isValidOption } from '../helpers/helpers';

function FilterCategory({ category, options, isExpanded, isActive, toggleCategory, handleChange, filtersValues, removeFilter }) {
  const activeFilters = filtersValues?.filter(filter => filter.filter_name === category);
  const hasActiveFilters = activeFilters && activeFilters.length > 0;

  return (
    <div className="category">
      <div className={`category__item ${isExpanded ? 'expanded' : ''} ${hasActiveFilters && !isExpanded ? 'no-indicator' : ''}`} onClick={toggleCategory}>
      <span className={`category__name ${isExpanded ? 'category__name--yellow' : ''}`}>{category}</span>
        {hasActiveFilters && !isExpanded && (
          <>
            <FilterCounter counter={activeFilters[0].filter_values.length} />
            <CloseFilterButton
              className="close_button--background"
              onClick={(e) => {
              e.stopPropagation();
              removeFilter(category);
            }}/>
          </>
        )}
      </div>
      <CSSTransition
        in={isExpanded}
        timeout={6000000}
        classNames="category-options"
        unmountOnExit
      >
        <div className="category-options">
          {Object.entries(options).map(([option, isChecked]) => {

            if (!isValidOption(option)) {
              return null;
            }
            return (
              <CustomCheckbox
              key={option}
              checked={isChecked}
              option={option}
              onChange={handleChange(category, option)} />);
          })}
        </div>
      </CSSTransition>
    </div>
  );
}


export default FilterCategory;
